import React from 'react';
import { Button } from 'react-bootstrap';
import LoadingPlaceholder from './../../shared/LoadingPlaceholder';
import ServiceModal from './ServiceModal';

import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import truncate from 'lodash/truncate';
import isNil from 'lodash/isNil';

import './servicecard.scss';

class ServiceCard extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showServiceModal: false
    }

    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.hideServiceModal = this.hideServiceModal.bind(this);
  }

  handleButtonClick() {
    this.setState({showServiceModal: true});
  }

  hideServiceModal() {
    this.setState({showServiceModal: false});
  }

  render() {

    const style = { backgroundImage: `url(${this.props.picture})` };

    let buttonStatusClass = '';

    switch (this.props.status) {
      case 'booked':
        buttonStatusClass = "customize-servicecard-component__link__booked";
        break;
      case 'wait_response':
        buttonStatusClass = "customize-servicecard-component__link__wait-response";
        break;
    }

    const button = (
      <div className="customize-servicecard-component__link-wrap">
        <Button className={`customize-servicecard-component__link ${buttonStatusClass}`} disabled={buttonStatusClass != ''} onClick={this.handleButtonClick}>
          <strong>{this.props.translate(`customize.service_card.status.${this.props.status}`)}</strong>
        </Button>
      </div>
    );

    let servicePrice = `${this.props.price} ${this.props.currency} ${this.props.payment_type}`;
    let freeService = false;
    switch (isNil(this.props.price) || isNaN(this.props.price) || parseFloat(this.props.price)) {
      case true:
        servicePrice = null;
        break;
      case 0:
        servicePrice = this.props.translate('customize.service_card.free');
        freeService = true;
        break;
    }

return (
  <div className="customize-servicecard-component" style={style}>
    <div className="customize-servicecard-component__overlay">
      
      {/* CORREZIONE 1: Rimosso <strong> inutile */}
      <h2 className="customize-servicecard-component__title">
          <LoadingPlaceholder ready={!!this.props.name} text-align="center">
            {this.props.name || <span></span>}
          </LoadingPlaceholder>
      </h2>

      {/* CORREZIONE 2: Cambiato h5 in div (o p) */}
      {/* Mantieni la stessa className per il CSS */}
      <div className="customize-servicecard-component__sub-title">
          <strong className={freeService ? 'text-success' : null}>
              {servicePrice}
          </strong>
      </div>

      <div className="customize-servicecard-component__content">
        <LoadingPlaceholder ready={!!this.props.description} text-align="center">
          {truncate(this.props.description, {length: 160, separator: ' '}) || <span></span>}
        </LoadingPlaceholder>
      </div>

      {this.props.status ? button : null}

    </div>

    <ServiceModal show={this.state.showServiceModal} onHide={this.hideServiceModal} {...this.props}/>

  </div>
);
  }
}

ServiceCard.displayName = 'PagesCustomizeServiceCard';
ServiceCard.propTypes = {};
ServiceCard.defaultProps = {};

const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale)
  };
};

export default connect(mapStateToProps)(ServiceCard);



// WEBPACK FOOTER //
// ./components/pages/customize/ServiceCard.js